module.exports = __webpack_public_path__ + "img/newcastle-united.3bf0091d.png";